export const OWNER_ROLE = 1;
export const MANAGER_ROLE = 2;
export const MEMBER_ROLE = 3;
export const ROLES = {
    [OWNER_ROLE]: 'Капитан',
    [MANAGER_ROLE]: 'Менеджер',
    [MEMBER_ROLE]: 'Игрок',
};
